import { makeObservable, observable, action } from 'mobx';
import { CardList, CardData, CardCompanyList } from 'types';

import { getUuid } from 'utils';
import { CARD_COMPANY, CARD_EDIT_TARGET_INDEX, DEFAULT_CARD } from 'constants/';

class CardWallet {
  list: CardList = [...DEFAULT_CARD];
  company: CardCompanyList = CARD_COMPANY;
  editIndex: number = CARD_EDIT_TARGET_INDEX.NEW;
  amountPaid = 0;

  constructor() {
    makeObservable(this, {
      list: observable,
      company: observable,
      editIndex: observable,
      amountPaid: observable,
      initial: action,
      setAmountPaid: action,
      setEditCardIndex: action,
      addCardData: action,
      updateCardData: action,
      removeCardData: action,
    });
  }

  initial({ cardList, companyList, amountPaid }): void {
    cardList && (this.list = cardList);
    companyList && (this.company = companyList);
    amountPaid && (this.amountPaid = amountPaid);
  }

  setAmountPaid(amount: number): void {
    this.amountPaid = amount;
  }

  setEditCardIndex(index: number): void {
    this.editIndex = index;
  }

  getCardData(index: number): CardData {
    return CARD_EDIT_TARGET_INDEX.NEW === index
      ? this.list[this.list.length - 1]
      : this.list[index];
  }

  addCardData(cardData: CardData): void {
    this.list.push({ ...cardData, id: getUuid() });
  }

  updateCardData(index: number, cardData: CardData): void {
    const targetCardData = this.list[index];
    if (!targetCardData) throw new Error('찾을 수 없는 카드 정보입니다.');

    this.list[index] = cardData;
  }

  removeCardData(index: number): void {
    const targetCardData = this.list[index];
    if (!targetCardData) throw new Error('찾을 수 없는 카드 정보입니다.');

    this.list.splice(index, 1);
  }
}

export default new CardWallet();
